import {useState, useEffect} from 'react';
import {AuthContext} from './AuthContext';
import {getCurrentUserData, getAuthTokenFromRefreshToken} from "../api/Authentication/api";

export const AuthProvider = ({children}) => {
  const [token, setToken] = useState(() => localStorage.getItem('token'));
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(!!token);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const validateTokenAndSetUser = async () => {
      if (token) {
        try {
          const userResponse = await getCurrentUserData();
          setUser(userResponse.data);
        } catch (error) {
          console.log('Token validation failed, attempting refresh:', error);
          localStorage.removeItem('token');
          
          const refreshToken = localStorage.getItem('refresh_token');
          if (refreshToken) {
            try {
              const refreshData = await getAuthTokenFromRefreshToken(refreshToken);
              localStorage.setItem('token', refreshData.data.access);
              localStorage.setItem('refresh_token', refreshData.data.refresh);
              setToken(refreshData.data.access);
              const userResponse = await getCurrentUserData();
              setIsAuthenticated(true);
              setUser(userResponse.data);
            } catch (error) {
              console.log('Token refresh failed:', error);
              localStorage.removeItem('refresh_token');
              setIsAuthenticated(false);
            }
          } else {
            setIsAuthenticated(false);
          }
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
        setIsAuthenticated(false);
      }
    };
    validateTokenAndSetUser();
  }, [token]);

  const handleSetUserDetails = async (tokenData) => {
    try {
      localStorage.setItem('token', tokenData.access);
      localStorage.setItem('refresh_token', tokenData.refresh);
      setToken(tokenData.access);

      const userResponse = await getCurrentUserData();
      const userData = userResponse.data;
      
      localStorage.setItem('userId', userData.id);
      localStorage.setItem('fullName', userData.name);
      localStorage.setItem('role', userData.role || '');
      
      setUser(userData);
      setIsAuthenticated(true);
    } catch (error) {
      console.error('Error setting user details:', error);
      setIsAuthenticated(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleLogout = () => {
    setToken(null);
    setUser(null);
    setIsAuthenticated(false);
    localStorage.removeItem('token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('userId');
    localStorage.removeItem('fullName');
    localStorage.removeItem('role');
    window.location.href = '/login';
  };

  const contextValue = {
    token,
    user,
    isAuthenticated,
    isLoading,
    setUserDetails: handleSetUserDetails,
    logout: handleLogout,
  };

  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  );
};